/**
 * El nombre del país en el idioma de la interfaz, o `null` si no hay país que
 * nombrar.
 *
 * Vive aquí y no dentro de un hook porque lo usan DOS superficies del mismo
 * dominio —el hover del sello del compositor y el del chip de la lista de
 * plantillas— y las dos contestan la misma pregunta: de qué depende el precio
 * que Meta cobra. Dos copias de esto es cómo una acaba diciendo «México» y la
 * otra «MX».
 *
 * `Intl.DisplayNames` devuelve el CÓDIGO cuando no conoce la región, así que
 * un ISO2 inválido pintaría «está en ZZ». Mismo criterio que `ConsumptionDetail`
 * ya aplica sobre la columna de destino: si el nombre vuelve igual al código,
 * no hay país que nombrar y quien llama omite la cláusula.
 */
export function countryLabel(iso2: string, locale: string): string | null {
  try {
    const name = new Intl.DisplayNames([locale], { type: 'region' }).of(iso2);
    return name && name !== iso2 ? name : null;
  } catch {
    return null;
  }
}
